import { Box, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import React from "react";

function TimelineRow(props) {
  const { logo, title, date, color, index, arrLength } = props;
  const textColor = useColorModeValue("purple.700", "white.300");
  const bgIconColor = useColorModeValue("white.300", "purple.700");

  return (
    <Flex alignItems="center" minH="78px" justifyContent="start" mb="5px">
      <Flex direction="column" h="100%">
        {/* <Icon
          as={logo}
          bg={bgIconColor}
          color={color}
          h={"30px"}
          w={"26px"}
          pe="6px"
          zIndex="1"
          position="relative"
          right={document.documentElement.dir === "rtl" ? "-8px" : ""}
          left={document.documentElement.dir === "rtl" ? "" : "-8px"}
        /> */}
        <Text fontSize="sm" color='white' fontWeight="bold" bg='purple.200' px='10px' py='3px' zIndex="1"
          position="relative"
          right={document.documentElement.dir === "rtl" ? "-12px" : ""}
          left={document.documentElement.dir === "rtl" ? "" : "-12px"}
          borderRadius='20px'>
          {logo}
        </Text>
        <Box
          w="1px"
          bg="purple.400"
          h={index === arrLength - 1 ? "16px" : "100%"}
        ></Box>
      </Flex>
      <Flex direction="column" justifyContent="flex-start" h="100%">
        <Text fontSize="md" color={"purple.300"} fontWeight="bold">
          {title}
        </Text>
        <Text fontSize="sm" color={textColor} fontWeight="normal">
          {date}
        </Text>
      </Flex>
    </Flex>
  );
}

export default TimelineRow;
